export function getWarningLevel(data) {
  return data === "silences" ? 1 : 2;
}
